import React from 'react'
import { useIntl } from 'react-intl'

interface ImageEditModalProps {
  isOpen: boolean
  onClose: () => void
  selectedImage: { id?: string; url: string; seoUrl?: string }
  onSave: (updatedImage: { url: string; seoUrl?: string }) => void
}

const ImageEditModal: React.FC<ImageEditModalProps> = ({ isOpen, onClose, selectedImage, onSave }) => {
  const [seoUrl, setSeoUrl] = React.useState(selectedImage.seoUrl || '')
  const [newImage, setNewImage] = React.useState<File | null>(null)
  const [previewImage, setPreviewImage] = React.useState(selectedImage.url)
  const intl = useIntl()

  React.useEffect(() => {
    setSeoUrl(selectedImage.seoUrl || '')
    setPreviewImage(selectedImage.url)
  }, [selectedImage])

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0]
      setNewImage(file)
      setPreviewImage(URL.createObjectURL(file))
    }
  }

  const handleSave = () => {
    const updatedImage = {
      url: newImage ? URL.createObjectURL(newImage) : selectedImage.url,
      seoUrl: seoUrl,
    }
    onSave(updatedImage)
  }

  if (!isOpen) return null

  return (
    <div className="modal modal-style">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{intl.formatMessage({
              id: 'COMMON.UPDATE_IMAGE'
            })}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <img
              src={previewImage.includes('/images/') ? process.env.REACT_APP_API_URL_IMAGE + previewImage : previewImage}
              alt="Selected"
              className='modal-body-image'
            />
            <div className="form-group mb-3">
              <label>{intl.formatMessage({
                id: 'COMMON.UPLOAD_IMAGE',
              })}</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleImageChange}
              />
            </div>
            {typeof selectedImage.url === 'string' && (
              <div className="form-group">
                <label>{intl.formatMessage({
                  id: 'COMMON.ALT_IMAGE',
                })} </label>
                <input
                  type="text"
                  className="form-control"
                  value={seoUrl}
                  onChange={(e) => setSeoUrl(e.target.value)}
                />
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>{intl.formatMessage({
              id: 'HEADER.RESET',
            })}</button>
            <button type="button" className="btn btn-primary" onClick={handleSave}>{intl.formatMessage({
              id: 'HEADER.SAVE',
            })}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImageEditModal